import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import styles from "./Details.module.scss";

// components
import FilterLoader from "../../../../components/Loader/FilterLoader";
import FilterButton from "../../../../components/Filters/FilterButton";
import SwitchFilter from "../../../../components/Filters/SwitchFilter";

// methods
import { useDispatch, useSelector } from "react-redux";
import { changeFilterLoader } from "../../../../redux/slices/filterSlice";
import CRMAPI from "../../../../services/crm-api";

// icons
import { LuBadgePercent } from "react-icons/lu";
import { IoReceiptSharp } from "react-icons/io5";
import { FiMapPin } from "react-icons/fi";
import DateRangeSelector from "../../../../components/Filters/DateRangeSelector";
import FieldAgentAPI from "../../../../services/field-agent-api";

export default function Details(props) {
  const { data, id } = props;
  const [report, setReport] = useState(null);

  const { filterLoader } = useSelector((state) => state.filter);
  const dispatch = useDispatch();

  const { getDashboardReportAPI } = new CRMAPI();
  const { fieldAgentReportAPI } = new FieldAgentAPI();

  useEffect(() => {
    fetchReportDetails();
  }, [filterLoader]);

  const fetchReportDetails = async () => {
    const res = await fieldAgentReportAPI(id);

    console.log(res);
    if (res.ok) {
      setReport(res.data);
    }
    dispatch(changeFilterLoader(false));
  };

  return (
    <Card elevation={0} sx={{ py: 1, borderRadius: 3 }}>
      <CardContent>
        <Grid container spacing={4}>
          <Grid size={12}>
            <Box display="flex" justifyContent="space-between" sx={{ mb: 2 }}>
              <Box className="header-title">
                <Typography variant="h4">Field Agent Report</Typography>
              </Box>
              <Box>
                <DateRangeSelector />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <CardContent>
        <Grid container spacing={4}>
          <Grid size={3}>
            <Box className={styles.dsaPerformance}>
              <Typography variant="h6">{report?.merchant_count}</Typography>
              <Typography variant="body2">Merchant Registration Count</Typography>
            </Box>
          </Grid>

          <Grid size={3}>
            <Box className={styles.dsaPerformance}>
              <Typography variant="h6">₹{report?.payout_amount}</Typography>
              <Typography variant="body2">Payout Amount</Typography>
            </Box>
          </Grid>

          <Grid size={3}>
            <Box className={styles.dsaPerformance}>
              <Typography variant="h6">₹{report?.paid_amount}</Typography>
              <Typography variant="body2">Paid Amount</Typography>
            </Box>
          </Grid>

          <Grid size={3}>
            <Box className={styles.dsaPerformance}>
              <Typography variant="h6">₹{report?.pending_amount}</Typography>
              <Typography variant="body2">Pending Amount</Typography>
            </Box>
          </Grid>

          <Grid size={3}>
            <Box className={styles.dsaPerformance}>
              <Typography variant="h6">{report?.payout_not_given}</Typography>
              <Typography variant="body2">Payout Not Given</Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>

      <CardHeader
        // action={
        //   <Box>
        //     <Button
        //       variant="outlined"
        //       sx={{ mr: 1, textTransform: "capitalize" }}
        //       size="small"
        //     >
        //       + Add New Bank
        //     </Button>
        //   </Box>
        // }
        title={
          <Box className="header-title">
            <Typography variant="h4">Bank Account Details</Typography>
          </Box>
        }
      />
      <CardContent>
        <TableContainer component={Paper}>
          <Table aria-label="lead table">
            <TableHead>
              <TableRow>
                <TableCell>Account Holder's Name</TableCell>
                <TableCell>Account Number</TableCell>
                <TableCell>Bank Name</TableCell>
                <TableCell>IFSC</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.profile?.bankDetails.length > 0 ? (
                <React.Fragment>
                  {data?.profile?.bankDetails?.map((row, index) => (
                    <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row.accountHolderName}
                      </TableCell>
                      <TableCell>{row.bankAccountNumber}</TableCell>
                      <TableCell>{row.bankName}</TableCell>
                      <TableCell>{row.IFSCCode}</TableCell>
                      <TableCell>{row.isActive ? "Active" : "Inactive"}</TableCell>
                    </TableRow>
                  ))}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                    <TableCell colSpan={5} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {filterLoader && <FilterLoader />}
      </CardContent>
    </Card>
  );
}
